import { render, staticRenderFns } from "./SalesDetails_Total.vue?vue&type=template&id=e9713474&"
import script from "./SalesDetails_Total.vue?vue&type=script&lang=js&"
export * from "./SalesDetails_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports